'use client'
import { GetUserProfileImage } from '@/app/dashboard/chat-bot/actions'
import React, { useEffect, useState } from 'react'
import TokensSm from '@/../public/images/tokens_sm.png';
import Image from "next/image";
import { TokenBalance } from '../TokenBalance';

interface IUserIconParams {
    userPicture?: string | null,
    userId?: string | null,
    photoOnly?: boolean
}

function UserIconTokens(params: IUserIconParams ) {
  const [profileImage, setProfileImage] = useState<string | null | undefined>(null);


  useEffect(() => {
    // Resolve the promise inside the effect
    if(params.userId) GetUserProfileImage(params.userId).then((url) => setProfileImage(url));
    else setProfileImage(params.userPicture);
  }, [params.userId, params.userPicture]);

  if(!params.photoOnly) {
    return (
      <div className="rounded-full border-2 border-indigo-300 px-2 py-2 lg:px-4 lg-py-2 flex items-center gap-x-3 divide-x-2 divide-indigo-400">
        {
          params.userId || params.userPicture ? 
          <TokenBalance />
          : null
        }
          <div className='pl-3'>
            <img src={ profileImage ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png" }
                alt="User Image Icon"
                className="rounded-full h8 w-8 hidden lg:block" referrerPolicy={'no-referrer'}
            />
          </div>
      </div>
    )
  } else  {
    return (
      <div className="rounded-full h-8 w-8">
          <img src={ profileImage ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png" }
              alt="User Image Icon"
              className="rounded-full h-8 w-8 block object-cover" 
              referrerPolicy={'no-referrer'}
          />
      </div>
    )
  }
}

export default UserIconTokens